import React from 'react';
import DiagnosticInsightsRouter from '../containers/DiagnosticInsightsRouter';
import DemoAccountContextProvider from '../contexts/DemoAccountContextProvider';

export default ({ isDemo = false, ...props }) => (
  <DemoAccountContextProvider isDemo={isDemo}>
    <DiagnosticInsightsRouter {...props} />
  </DemoAccountContextProvider>
);
